<template>
  <div class="privacy-inner">
    <div class="container">
      <div class="inner__wrapper">
        <h2 class="title">개인정보 처리방침</h2>
        <p class="desc">
          ‘하이콘소프트‘는 (이하 ‘회사‘는) 고객님의 개인정보를 중요시하며,
          “정보통신망 이용촉진 및 정보보호“에 관한 법률을 준수하고 있습니다.
          회사는 개인정보처리방침을 통하여 고객님께서 제공하시는 개인정보가
          어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한
          조치가 취해지고 있는지 알려드립니다. 회사는 개인정보처리방침을
          개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할
          것입니다. 본 방침은 2023년 9월 22일부터 시행됩니다.
        </p>
        <h3 class="tit">개인정보의 수집 및 이용목적</h3>
        <div class="desc">
          수집하는 개인정보 항목 회사는 상담, 서비스 신청 등을 위해 아래와 같은
          개인정보를 수집하고 있습니다. 회사는 수집한 개인정보를 다음의 목적을
          위해 활용합니다.
          <p class="list">
            수집항목 : 이름 , 휴대전화번호 , 이메일 , 회사명 상담내용
          </p>
          <p class="list">개인정보 수집방법 : 홈페이지(상담폼)</p>
          <p class="list">
            정보이용 및 신청에 따른 본인확인 , 개인 식별 , 불만처리 등 민원처리
          </p>
        </div>

        <h3 class="tit">개인정보의 보유 및 이용기간</h3>
        <p class="desc">
          회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외 없이 해당 정보를
          지체 없이 파기합니다.
        </p>
        <h3 class="tit">개인정보의 파기절차 및 방법</h3>
        <div class="desc">
          회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당
          정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
          <p class="list">
            제품 문의를 위해 입력하신 개인정보는 목적이 달성된 후 별도의 DB로
            옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한
            정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후
            파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가
            아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.
          </p>
          <p class="list">파기방법 – DB삭제 방법으로 파기합니다.</p>
        </div>
        <h3 class="tit">개인정보 제공</h3>
        

        <div class="desc">
          회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만,
          아래의 경우에는 예외로 합니다.
          <p class="list">이용자들이 사전에 동의한 경우</p>
          <p class="list">
            법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에
            따라 수사기관의 요구가 있는 경우
          </p>
        </div>
        <h3 class="tit">수집한 개인정보의 위탁</h3>
        <p class="desc">
          회사는 고객님의 동의없이 고객님의 정보를 외부 업체에 위탁하지
          않습니다. 향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에
          대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.
        </p>

        <h3 class="tit">이용자 및 법정대리인의 권리와 그 행사방법</h3>

        <p class="desc">
          이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세
          미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할
          수도 있습니다. 이용자 혹은 만 14세 미만 아동의 개인정보 조회 · 수정을
          위해서는 ‘개인정보변경‘(또는 ‘회원정보수정’ 등)을 가입해지(동의철회)를
          위해서는 “회원탈퇴“를 클릭 하여 본인 확인 절차를 거치신 후 직접 열람,
          정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 서면, 전화
          또는 이메일로 연락하시면 지체없이 조 치하겠습니다. 귀하가 개인정보의
          오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까 지 당해
          개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자
          에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여
          정정이 이루어지도록 하겠습니다. 하이콘소프트는 이용자 혹은 법정
          대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “하이콘소프트가
          수집하는 개인정보의 보유 및 이용기간“에 명시된 바에 따라 처리하고 그
          외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. 개인정보
          자동수집 장치의 설치, 운영 및 그 거부에 관한 사항 쿠키 등 인터넷
          서비스 이용 시 자동 생성되는 개인정보를 수집하는 장치를 운영하지
          않습니다.
        </p>
        <h3 class="tit">개인정보에 관한 민원서비스</h3>
        <div class="desc">
          회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기
          위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고
          있습니다. 개인정보관리책임자
          <p class="list">책임자:황재호 책임</p>
          <p class="list">연락처: 070-8846-5577</p>
          <p class="list">담당자 연락처: 010-8542-3405</p>
          귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련
          민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다.
        </div>
        <div class="desc">
          개인정보관리책임자
          <p class="list">국번없이 118</p>
          <p class="list">privacy.kisa.or.kr</p>
          정보보호마크인증위원회
          <p class="list">02-550-9531~2</p>
          <p class="list">www.eprivacy.or.kr</p>
          개인정보관리책임자
          <p class="list">국번없이 1301</p>
          <p class="list">www.spo.go.kr</p>
          개인정보관리책임자

          <p class="list">국번없이 182</p>
          <p class="list">cyberbureau.police.go.kr</p>
        </div>
      </div>
    </div>
    <pageFooter />
  </div>
</template>

<script>
import pageFooter from "@/components/pageFooter.vue";
export default {
  components: { pageFooter },
  created() {
    //Y축 휠 오픈
    document.body.style.overflowY = "auto";
  }
};
</script>

<style></style>
